import makeStyles from "@material-ui/core/styles/makeStyles";


const useStyles= makeStyles({
    video:{
        width:'100%',
        height:'99.5vh',
        objectFit:'cover',
        zIndex:'-100',
        position:'relative'
    },
    header:{
        width:'100vw',
        height:'100vh',
        backgroundColor:'rgba(0,0,0,0.91)',
        zIndex:'100',
        position:'absolute'
    }

})
export default useStyles;